/* LiveChat's app embed supplies the widget and Shopify integration. */
(() => {
  const launcher = document.getElementById('SchucoChatLauncher');
  if (!launcher || !window.schucoChatOnDemand || launcher.dataset.bound) return;
  launcher.dataset.bound = 'true';
  const button = launcher.querySelector('button');
  const label = launcher.querySelector('.schuco-chat-launcher__label');
  const status = launcher.querySelector('[role="status"]');
  const fallback = launcher.querySelector('a');
  let bound = false;
  let started = !window.__lc?.asyncInit;
  let requested = false;
  let ready = false;
  let timeout;

  const showFallback = () => {
    if (ready) return;
    button.removeAttribute('aria-busy');
    label.textContent = 'Chat with Schuco';
    status.textContent = 'Chat is taking longer to load. You can contact the Schuco team here.';
    fallback.hidden = false;
  };

  const bind = () => {
    const widget = window.LiveChatWidget;
    if (bound || !widget?.on || !widget?.init) return;
    bound = true;
    document.removeEventListener('load', bind, true);
    const onReady = () => {
      ready = true;
      clearTimeout(timeout);
      launcher.hidden = true;
      if (requested) widget.call('maximize');
    };
    widget.on('ready', onReady);
    try {
      if (widget.get('state')) onReady();
    } catch (error) {
      // The app's queue deliberately rejects getters before the widget is ready.
    }
    if (!ready) launcher.hidden = false;
    button.addEventListener('click', () => {
      requested = true;
      if (ready) {
        widget.call('maximize');
        return;
      }
      button.setAttribute('aria-busy', 'true');
      label.textContent = 'Opening chat…';
      status.textContent = 'Opening chat with Schuco.';
      clearTimeout(timeout);
      timeout = setTimeout(showFallback, 15000);
      if (started) return;
      started = true;
      try {
        sessionStorage.setItem('schuco:chat-started', 'true');
      } catch (error) { /* Chat still works when storage is unavailable. */ }
      try {
        widget.init();
      } catch (error) {
        showFallback();
      }
    });
  };

  // Capturing load also handles an app bootstrap that finishes after theme JS.
  document.addEventListener('load', bind, true);
  bind();
})();
